import { useBusinessCentralCompanyShowQuery } from "@/services/backend/business-central/api/company-api";

export function BusinessCentralCompanyName({
  companyId,
}: {
  companyId: string;
}) {
  const { data } = useBusinessCentralCompanyShowQuery({ id: companyId });

  if (!data) {
    return null;
  }

  return <span>{data.name}</span>;
}
